export enum ERoleType {
	ADMIN = 'admin',
	CUSTOMER = 'customer',
	AGENT = 'agent',
	DELIVERY_COMPANY = 'delivery_company',
	DRIVER = 'driver',
	SUPPLIER = 'supplier',
	STORE_MANAGER = 'store_manager',
}